import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function HistoriqueStock() {

  const userData = useSelector(state => state.userData);

  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_URL;

  const id = userData.id;
  const apitoken = userData.apitoken;

  const today = new Date();

  const todayDate =
    today.getFullYear() +
    "-" +
    String(today.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(today.getDate()).padStart(2, "0");

  const [selectedDate, setSelectedDate] = useState(todayDate);

  const [loading, setLoading] = useState(false);

  const [produits, setProduits] = useState([]);


  const [nbProduits, setNbProduits] = useState(0);

  const [totalUnites, setTotalUnites] = useState(0);

  const [valeurStock, setValeurStock] = useState(0);

  const [dateDebutExport, setDateDebutExport] = useState(todayDate);
const [dateFinExport, setDateFinExport] = useState(todayDate);
const [exportLoading, setExportLoading] = useState(false);

  //----------------------------------------------------

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  //----------------------------------------------------

  const GetPack = (nb_unite, qte_pack) => {

    return Math.floor(nb_unite / qte_pack);

  };

  const GetUnite = (nb_unite, qte_pack) => {

    return nb_unite % qte_pack;

  };

  //----------------------------------------------------

  const FormatMoney = (value) => {

    return Number(value).toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  };

  //----------------------------------------------------


  const exportCSV = async () => {

  if (!dateDebutExport || !dateFinExport) {
    alert("Veuillez sélectionner une date de début et une date de fin");
    return;
  }

  if (dateDebutExport > dateFinExport) {
    alert("La date de début doit être inférieure ou égale à la date de fin");
    return;
  }

  try {

    setExportLoading(true);

    const response = await axios.post(
      `${apiUrl}stock/history-range/${id}/${apitoken}/${dateDebutExport}/${dateFinExport}`,
      {},
      {
        timeout: 60000,
      }
    );

    const snapshots = response.data.snapshots || [];

    if (snapshots.length === 0) {
      alert("Aucune donnée disponible pour cette période");
      return;
    }

    const csvRows = [];

    // En-tête CSV
    csvRows.push(
      [
        "Date",
        "Désignation",
        "Packs",
        "Unités",
        "Prix achat",
        "Valeur"
      ].join(";")
    );

    snapshots.forEach((snapshot) => {

      const date = new Date(snapshot.date);

      const dateFormatted =
        String(date.getDate()).padStart(2, "0") +
        "/" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "/" +
        date.getFullYear();

      const produits = snapshot.produits || [];

      produits.forEach((produit) => {

        const packs = GetPack(
          produit.stock,
          produit.qte_pack
        );

        const unites = GetUnite(
          produit.stock,
          produit.qte_pack
        );

        const valeur =
          produit.stock * produit.prix_achat;

        csvRows.push(
          [
            dateFormatted,

            `"${String(produit.designation)
              .replace(/"/g, '""')}"`,

            packs,

            unites,

            Number(produit.prix_achat)
              .toFixed(2)
              .replace(".", ","),

            Number(valeur)
              .toFixed(2)
              .replace(".", ",")
          ].join(";")
        );

      });

    });

    // BOM UTF-8 pour Excel
    const csvContent =
      "\uFEFF" + csvRows.join("\r\n");

    const blob = new Blob(
      [csvContent],
      {
        type: "text/csv;charset=utf-8;"
      }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download =
      `stock_${dateDebutExport}_${dateFinExport}.csv`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);

  }
  catch (error) {

    console.error(error);

    if (error.response?.data?.detail) {
      alert(error.response.data.detail);
    }
    else {
      alert("Erreur pendant l'export CSV");
    }

  }
  finally {

    setExportLoading(false);

  }

};

  const getHistorique = async () => {

    setLoading(true);

    try {

      const response = await axios.post(

        `${apiUrl}stock/history/${id}/${apitoken}/${selectedDate}`,

        {},

        {
          timeout: 20000,
        }

      );

      const rep = response.data;

      setNbProduits(rep.nb_produits);

      setTotalUnites(rep.total_unites);

      setValeurStock(rep.valeur_stock);

      const sorted = [...rep.produits].sort((a, b) => {

        return (
          (b.stock * b.prix_achat) -
          (a.stock * a.prix_achat)
        );

      });

      setProduits(sorted);

    }

    catch (error) {

      navigate("/");

    }

    setLoading(false);

  };

  //----------------------------------------------------

  useEffect(() => {

    getHistorique();

  }, [selectedDate]);

  //----------------------------------------------------



  //----------------------------------------------------

  const ShowList = () => {

    if (produits.length === 0) {

      return (

        <StyledTableRow>

          <StyledTableCell
            align="center"
            colSpan={5}
          >

            Pas de données

          </StyledTableCell>

        </StyledTableRow>

      );

    }

    return produits.map((produit) => {

      const valeur =
        produit.stock * produit.prix_achat;

      return (

        <StyledTableRow
          key={produit._id}
        >

          <StyledTableCell>

            {produit.designation}

          </StyledTableCell>

          <StyledTableCell>

            {GetPack(
              produit.stock,
              produit.qte_pack
            )}

          </StyledTableCell>

          <StyledTableCell>

            {GetUnite(
              produit.stock,
              produit.qte_pack
            )}

          </StyledTableCell>

        <StyledTableCell
            align="right"
        >

            {FormatMoney(
                produit.prix_achat
            )} DH

        </StyledTableCell>

        <StyledTableCell
            align="right"
            sx={{
                fontWeight: "bold"
            }}
        >

            {FormatMoney(valeur)} DH

        </StyledTableCell>

        </StyledTableRow>

      );

    });

  };

  //----------------------------------------------------


  return (

<Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>

    <Typography
        variant="h4"
        align="center"
        color="primary"
        gutterBottom
    >
        Historique du Stock
    </Typography>

<Stack
    sx={{
        mt: 4,
        mb: 4
    }}
>

        <TextField

            type="date"

            label="Date"

            value={selectedDate}

            onChange={(e) =>
                setSelectedDate(
                    e.target.value
                )
            }

            InputLabelProps={{
                shrink: true,
            }}

            sx={{
                width: 220
            }}

        />

    </Stack>

    <Grid
        container
        spacing={3}
        sx={{
            mb: 4
        }}
    >

        <Grid
            item
            xs={12}
            md={4}
        >

            <Card elevation={3}>

                <CardContent>

                    <Typography
                        variant="subtitle2"
                        color="text.secondary"
                    >
                        Nombre de produits
                    </Typography>

                    <Typography
                        variant="h4"
                        color="primary"
                    >
                        {nbProduits}
                    </Typography>

                </CardContent>

            </Card>

        </Grid>

        <Grid
            item
            xs={12}
            md={4}
        >

            <Card elevation={3}>

                <CardContent>

                    <Typography
                        variant="subtitle2"
                        color="text.secondary"
                    >
                        Total unités
                    </Typography>

                    <Typography
                        variant="h4"
                        color="primary"
                    >
                        {FormatMoney(totalUnites)}
                    </Typography>

                </CardContent>

            </Card>

        </Grid>

        <Grid
            item
            xs={12}
            md={4}
        >

            <Card elevation={3}>

                <CardContent>

                    <Typography
                        variant="subtitle2"
                        color="text.secondary"
                    >
                        Valeur du stock
                    </Typography>

                    <Typography
                        variant="h4"
                        color="success.main"
                    >
                        {FormatMoney(valeurStock)} DH
                    </Typography>

                </CardContent>

            </Card>

        </Grid>

    </Grid>

    {

        loading ?

        <Skeleton

            variant="rounded"

            height={500}

        />

        :

        <>
        <Box
  sx={{
    mt: 4,
    p: 3,
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 2
  }}
>

  <Typography
    variant="h6"
    gutterBottom
  >
    Exporter
  </Typography>

  <Stack
    direction={{
      xs: "column",
      sm: "row"
    }}
    spacing={2}
    alignItems={{
      xs: "stretch",
      sm: "center"
    }}
  >

    <TextField
      type="date"
      label="Date début"
      value={dateDebutExport}
      onChange={(e) =>
        setDateDebutExport(e.target.value)
      }
      InputLabelProps={{
        shrink: true,
      }}
      sx={{
        width: {
          xs: "100%",
          sm: 220
        }
      }}
    />

    <TextField
      type="date"
      label="Date fin"
      value={dateFinExport}
      onChange={(e) =>
        setDateFinExport(e.target.value)
      }
      InputLabelProps={{
        shrink: true,
      }}
      sx={{
        width: {
          xs: "100%",
          sm: 220
        }
      }}
    />

    <Button
      variant="contained"
      onClick={exportCSV}
      disabled={exportLoading}
      sx={{
        height: 56
      }}
    >
      {
        exportLoading
          ? "Export..."
          : "Exporter"
      }
    </Button>

  </Stack>

</Box>
        
        

        <TableContainer
            component={Paper}
        >

            <Table>

                <TableHead>

                    <TableRow>

                        <StyledTableCell>
                            Désignation
                        </StyledTableCell>

                        <StyledTableCell
                            align="center"
                        >
                            Packs
                        </StyledTableCell>

                        <StyledTableCell
                            align="center"
                        >
                            Unités
                        </StyledTableCell>

                        <StyledTableCell
                            align="right"
                        >
                            Prix achat
                        </StyledTableCell>

                        <StyledTableCell
                            align="right"
                        >
                            Valeur
                        </StyledTableCell>

                    </TableRow>

                </TableHead>

                <TableBody>

                    <ShowList/>

                </TableBody>

            </Table>

        </TableContainer>
        </>

    }

</Container>

);

}